module.exports = __webpack_public_path__ + "img/logo-small.3035118d.svg";